import { Injectable } from '@angular/core';
import {urls} from '../../../services/api/urls';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import * as servers from '../../../services/api/servers';
import {GeneralServices} from '../../../services/general-services';

@Injectable({
  providedIn: 'root'
})
export class ContractualDataService implements GeneralServices {

  constructor(private http: HttpClient) {
  }

  delete(url: string, id: number) {
  }

  getAll(url: string, filters: any): Observable<any> {
    url = url + 'list';

    this.http.get(url).subscribe(
      data => {
        console.log('successo');
      },
      error => {
        console.log('errore');
      }
    );

    return null;
  }

  getById(url: string) {
  }

  save(url: string, object: any) {
  }

  update(url: string, object: any, id: number) {
  }

}
